import AccessNotice from "../components/AccessNotice";
export default function OrganizationSetupInfo() {
  return <AccessNotice kind="setup" />;
}
